// Bootstrap tooltip bootstrapping.

global.tooltips = {
  init: function() {    
    $('[data-toggle="tooltip"]').tooltip({container: '#content-wrapper'});
  }
};

// SignatureChannel delivers "somebody signed" events on EVERY page — this
// dispatcher always exists; pages that react (prematch, scoresheet, report)
// define confirmSigned on their Twine context, everywhere else it is a no-op.
